import OrgIdList from '../data/OrgIdName.json';
import * as _ from 'lodash';


export const generateRandomNumber = (min, max) => {
  const rand = Math.floor(Math.random() * Math.floor(max));
  return rand;
};

export const generateRandomLetter = () => {
  const alphabet = "abcdefghijklmnopqrstuvwxyz"
  return alphabet[Math.floor(Math.random() * alphabet.length)]; 
};

export const is_numeric_char = (c) => {
  const re = /^\d$/;
   return re.test(c);
};

export const  getOrgId = (orgName) => {
  let orgId = "";
  OrgIdList.OrgMapping.map(item => {
    if(item.orgName === orgName){
      orgId =  item.orgId;
    }
  });
  return orgId;
}

export const randomPaddedIntString =  (min, max, padString, length) =>
{
  var str = Math.floor(Math.random() * (max - min + 1) + min);

  while (str.length < length)
  {
    str = padString + str;
  }
  return str;
}

export const removeSpace = (output) => {
  let value;
  if (typeof output === 'string') {
    return _.trim(output);
  }
  for (let key in output) {
    value = output[key];
    if (typeof value === 'string'){
      output[key] = _.trim(value);
    }else if(typeof value === 'object' && !Array.isArray(value) ){
      output[key] = removeSpace(value);
    }
  }
  return output;
}

export const timer = (counter) => {
  let mins =  Math.floor(counter / 60);
  let secs = counter - mins*60 ;
  if(mins < 10) {
    mins = '0' + mins;
  }
  if(secs < 10) {
    secs = '0' + secs;
  }
  return mins + ':' + secs;
}

export const getFeatureFlag = (featureName, featureFlags) => {
  if(!_.isEmpty(featureFlags)){
    const index = _.findIndex(featureFlags, function (o) {
      return o.featureName === featureName;
    });
    return featureFlags[index].isActive;
  } else {
    return false;
  }
};
